import request from "../../config/fetch"

export default {
  get: (path, body, headers, autoHandle, autoControlSpinner) =>
    request(
      path,
      { method: "get", body },
      headers,
      autoHandle,
      autoControlSpinner,
    ),
  post: (path, body, headers, autoHandle, autoControlSpinner) =>
    request(
      path,
      { method: "post", body },
      headers,
      autoHandle,
      autoControlSpinner,
    ),
  put: (path, body) => request(path, { method: "put", body }),
  delete: (path, body) => request(path, { method: "delete", body }),
}



// WEBPACK FOOTER //
// ./src/utils/http/index.js